import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'set_promoted_branch_data': {
      return { ...data, data: payload.data }
    }
    case 'show_hide_vehicle_popup': {
      return { ...data, showVehicleModal: payload.data }
    }
    case 'show_hide_file_selection_popup': {
      return {
        ...data,
        showFileSelection: payload.data,
        selectedVehicle: payload?.selectedVehicle,
        showVehicleModal: payload?.showVehicleModal,
        selectedFiles: payload?.selectedFiles,
      }
    }
    case 'set_selected_files': {
      return {
        ...data,
        selectedFiles: payload?.data,
      }
    }
    case 'promote_files_data': {
      return {
        ...data,
        promoteFilesData: payload?.data,
      }
    }
    case 'show_hide_tracer_preview': {
      return {
        ...data,
        showTracerPreviewPopup: payload?.data,
      }
    }
    case 'set_tracer_preview_data': {
      return {
        ...data,
        tracerPreviewData: payload.data,
      }
    }
    case 'reset_tracer_preview': {
      return {
        ...data,
        tracerPreviewData: {},
        showTracerPreviewPopup: false,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: {},
  selectedData: {},
  showVehicleModal: false,
  showFileSelection: false,
  selectedVehicle: {},
  selectedFiles: {},
  promoteFilesData: {},
  showTracerPreviewPopup: false,
  tracerPreviewData: {},
}

const PromotedBranchStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <PromotedBranchContext.Provider value={[state, dispatch]}>
      {children}
    </PromotedBranchContext.Provider>
  )
}

export const PromotedBranchContext = createContext(initialState)
export default PromotedBranchStore
